import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultTransactionData = {
  id: 0,
  userId: undefined,
  orderId: undefined,
  orderReference: undefined,
  transactionReference: undefined,
  transactionDate: undefined,
  status: undefined,
  productinfo: '',
  amount: 0,
  paymentGateway: '',
  paymentMethod: undefined,
  bank: undefined,
  utrNumber: null,
  errorCode: '',
  errorMessage: '',
  user: {
    id: undefined
  }
};
export const getTransactions = params => request({
  url: '/transactions',
  method: 'get',
  params
});
export const getAllTransactions = data => request({
  url: '/transactions/get-all',
  method: 'post',
  data
});
export const createTransaction = data => request({
  url: '/transactions',
  method: 'post',
  data
});
export const getTransactionById = id => request({
  url: `/transactions/${id}`,
  method: 'get'
});
export const editTransactionById = (id, data) => request({
  url: `/transactions/edit/${id}`,
  method: 'post',
  data
});
export const updateTransaction = (id, data) => request({
  url: `/transactions/${id}`,
  method: 'patch',
  data
});
export const deleteTransaction = id => request({
  url: `/transactions/${id}`,
  method: 'delete'
});
export const deleteTransactionWithLedger = data => request({
  url: '/transactions/delete-with-ledger',
  method: 'post',
  data
});
export const downloadExcel = data => request({
  url: '/transactions/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});